import React from "react";

import cls from "./Spinner.less";

export default () => <div className={cls.loader} />;
